module.exports = __webpack_public_path__ + "img/tata-aia.28593b29.jpg";